<template>
    <div @click="handleUpload" class="single-pic-upload">
        <el-icon v-if="!value" name="upload"  class="icon" ></el-icon>
        <el-image v-else :src="$api.commonFile.download + '?code=' + value" fit="contain"></el-image>
    </div>
</template>

<script>
    import {Loading} from "element-ui";
    export default {
        name: "SinglePicUploader",
        props:{
            category:{
                type:String,
                default:''
            },
            value:{
                type:String,
                default:''
            }
        },
        methods:{
            handleUpload(){

                let vm = this;
                let input = document.createElement("input");
                input.type="file";
                input.multiple=true;
                input.onchange = async ()=>{

                    if(input.files && input.files.length){


                        let loading = Loading.service({ fullscreen: true,text:'文件上传中...'});

                        //开始上传文件
                        let formData = new FormData();
                        formData.append("file",input.files[0]);
                        formData.append("category",vm.category);

                        let res = await vm.$http.post(vm.$api.cmsCommon.uploadFile,formData);

                        loading.close();
                        if(res.data.status === 200){
                            vm.$emit('input',res.data.data.code)
                        }

                    }else{
                        vm.$emit('input','')
                    }

                };
                input.click();

            }
        }
    }
</script>

<style scoped>

    .single-pic-upload{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 192px;
        height: 108px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .icon{
        font-size: 28px;
        color: #8c939d;
    }

</style>